import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const ProjectCard = ({ project, i = 0, large = false }) => (
  <motion.article
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    className="group"
  >
    <Link to={`/projects/${project.slug}`} data-testid={`project-card-${project.slug}`} className="block">
      <div className={`relative overflow-hidden rounded-3xl bg-mist ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
        <img
          src={project.lead_image}
          alt={`${project.title} — ${project.type} project in ${project.location}, ${project.country} (placeholder image)`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-expo group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-coal/0 group-hover:bg-coal/15 transition-colors duration-700" />
        <span className="absolute top-4 left-4 label-tech glass-dark text-paper px-4 py-2 rounded-full">
          {project.status}
        </span>
        <span className="absolute bottom-4 right-4 w-11 h-11 rounded-full flex items-center justify-center glass text-coal opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 ease-expo">
          <ArrowUpRight size={18} />
        </span>
      </div>
      <div className="flex items-start justify-between gap-4 pt-5">
        <div>
          <p className="label-tech text-graphite mb-2.5">
            {project.location}, {project.country} — {project.year}
          </p>
          <h3 className={`${large ? "t-h3" : "text-xl font-semibold tracking-[-0.01em]"} text-coal group-hover:text-cobalt transition-colors duration-300`}>
            {project.title}
          </h3>
          <p className="text-sm text-graphite mt-2">{project.scope.join(" · ")}</p>
        </div>
        <span className="label-tech text-ink/30 pt-1">{String(i + 1).padStart(2, "0")}</span>
      </div>
    </Link>
  </motion.article>
);

export default ProjectCard;
